module.exports = __webpack_public_path__ + "img/extension.9e70949e.svg";